import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import clsx from "clsx";
import styles from "./index.module.scss";
import Maper from "/components/pages/contacts/maper";
import { Api } from "/api";

export default function OldMap({ isBaltex }) {
  const { shops } = useSelector((state) => state.location);
  const { cityName, deliveryCityData, deliveryCityDataLoaded } = useSelector(
    (state) => state.location,
  );
  const { contactsData, contacts } = useSelector((state) => state.contacts);
  const [pointId, setPointId] = useState(null);
  const [edostPoints, setEdostPoints] = useState([]);
  let currentShops = [];
  if (contactsData?.SHOPS) {
    currentShops = contactsData?.SHOPS.map((id) => shops[id]).filter(
      (shop) => shop,
    );
  }
  let points = currentShops;
  if (contactsData.ID === "86897") {
    points = Array.isArray(edostPoints) ? edostPoints : [];
  }
  if (cityName === "Россия" && contacts.length > 0) {
    points = [...contacts[0].SHOPS, ...contacts[1].SHOPS]
      .map((id) => shops[id])
      .filter((shop) => shop);
  }
  const isSdek = cityName !== "Россия" && contactsData.ID === "86897";
  // eslint-disable-next-line no-nested-ternary
  const zoom = isSdek ? 10 : points.length > 2 ? 5 : 9;

  useEffect(async () => {
    if (isSdek && deliveryCityDataLoaded) {
      setEdostPoints(
        await Api.edost.getPointsOld(
          cityName,
          `${deliveryCityData?.region} ${deliveryCityData?.region_type_full}`,
        ),
      );
    }
  }, [isSdek, cityName, deliveryCityDataLoaded]);
  return (
    <div className={styles.Contacts}>
      <div className={styles.Info}>
        <div>
          <div>Телефон:</div>
          <a
            href={`tel:${contactsData?.PHONE}`}
            className={contactsData?.CALL_TOUCH_CODE}
          >
            {contactsData?.PHONE}
          </a>
        </div>
        <div>
          <div>Эл. почта</div>
          <a href={`mailto:${contactsData?.EMAIL}`}>{contactsData?.EMAIL}</a>
        </div>
      </div>

      <div className={clsx(styles.Adreses, isBaltex && styles.AdresesBaltex)}>
        <div className={styles.Adr}>
          {currentShops.map((shop, i) => (
            <div key={i} className={styles.AdrBlock}>
              {shop.DRIVE_SCHEME && (
                <div
                  className={clsx(
                    styles.Scheme,
                    shop.ID === pointId && styles.SchemeSelected,
                  )}
                  onClick={() => setPointId(shop.ID)}
                >
                  Схема проезда
                </div>
              )}
              <div>Адрес:</div>
              <span dangerouslySetInnerHTML={{ __html: shop["~ADR"] }} />
              {shop.WORK_TIME && (
                <>
                  <div>Режим работы:</div>
                  <span>{shop?.WORK_TIME}</span>
                </>
              )}
            </div>
          ))}
        </div>
        <div className={styles.Map}>
          <Maper zoom={zoom} points={points} pointId={pointId} />
        </div>
      </div>
    </div>
  );
}
